<script setup lang="ts">
interface Props {
  title: string;
  subtitle?: string | string[];
  size?: 'small' | 'medium' | 'large';
  hasIcon?: boolean;
  modelValue: boolean;
  variant?: 'success' | 'danger';
  closable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  subtitle: undefined,
  size: 'medium',
  hasIcon: false,
  default: true,
  variant: 'success',
  closable: true,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();
const isModalActive = computed({
  set(newValue: boolean) {
    emit('update:modelValue', newValue);
  },
  get() {
    return props.modelValue;
  },
});
</script>

<template>
  <UiOverlay v-model="isModalActive">
    <UiModal
      :title="props.title"
      :subtitle="props.subtitle"
      :variant="props.variant"
      :size="props.size"
      :closable="props.closable"
      @close="isModalActive = false"
    >
      <template v-if="hasIcon" #icon>
        <slot name="icon"></slot>
      </template>
      <template v-if="$slots.topActions" #topActions>
        <slot name="topActions"></slot>
      </template>
      <slot name="content"></slot>

      <div class="dialog__actions">
        <slot name="actions"></slot>
      </div>
    </UiModal>
  </UiOverlay>
</template>

<style lang="scss">
// TODO: Remove important once we decide how we gonna handle modals
.ui-modal-card {
  &__center {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
  }
}
</style>
